import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { environment } from '@env/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class DepartamentoService extends BaseAPIClass {
  baseUrl = environment.serverBaseUrl;

  constructor(protected httpClient: HttpClient, handler: HttpBackend) {
    super(httpClient);
    this.httpClient = new HttpClient(handler);
    this.baseUrl = this.baseUrl + '/departamentos';
  }

  // constructor(protected httpClient: HttpClient) {
  //   super(httpClient);
  //   this.baseUrl = '/departamentos';
  // }
}
